@if (disclaimerText && mediaType === 'disclaimer') {
  <span class="contentful-disclaimer">{{ disclaimerText }}</span>
}
